// /** COLORS */
export const colorPlayYellow2 = '#fcc346';

// //Brand
export const brandColorBlue1 = '#0f418c';
export const brandColorBlue2 = '#1e69aa';

export const brandColorPurple1 = '#641e78';
export const brandColorPurple2 = '#410f5a';

export const brandColorGreen1 = '#197869';
export const brandColorGreen2 = '#2d9b91';

/** COLORS */
export const regularWhite = '#ffffff';
export const extraLightCoolGrey = '#e6ebeb';
export const darkCoolGrey = '#647378';
export const playGrey20 = '#2e3233';
export const playGrey15 = '#222526';
export const playGrey10 = '#171a1a';
export const playGrey5 = '#0b0c0d';
export const regularBlack = '#000000';

export const accentGreen = '#00c800';

export const darkBlue = '#1e69aa';
export const extraDarkBlue = '#0f418c';
export const accentBlue = '#0091ff';

export const regularRed = '#e13241';
export const darkRed = '#b9232d';

export const lightYellow = '#ffdc8c';
export const regularYellow = '#ffc346';
export const accentYellow = '#fff000';

export const darkPurple = '#641e78';
export const extraDarkPurple = '#410f5a';

export const extraDarkTurquoise = '#197869';
export const darkTurquoise = '#2d9b91';

/** SCREEN SIZES */
export const xsmall = '29.6423em'; // 474px
export const small = '37.5625em'; // 601px
export const maxSmall = '50em'; // 800px
export const medium = '50.0625em'; // 801px
export const large = '64.0625em'; // 1025px
export const xlarge = '80.0625em'; // 1281px
export const fullScreen = '120.0625em'; // 1921px

/** FONT */
export const fontFamilySansSerif = 'publik, helvetica, arial, sans-serif';
export const fontFamilyRegular = fontFamilySansSerif;

/** FONT WEIGHTS */
export const fontWeightLight = 300;
export const fontWeightRegular = 400;
export const fontWeightBold = 700;
export const fontWeightExtraBold = 800;

/** MARGINS */
export const defaultTextMargin = '0.1em';

/** TRANSITIONS */
export const playTransitionEasing = 'cubic-bezier(0.5, 0, 0.1, 1)';
export const playTransitionDescription = 'cubic-bezier(0.18, 0.61, 0.43, 0.95)';
export const playTransitionRecommendations = 'cubic-bezier(0.25, 0.1, 0.25, 1)';
export const playTransitionCubicEaseInOut = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

/** TIMING */
export const SlashTiming = 700;

/** ICONS */
export const iconAirPlay = '\f101';
export const iconAngleDown = '\f102';
export const iconAngleLeft = '\f103';
export const iconAngleRight = '\f104';
export const iconAngleUp = '\f105';
export const iconArrowDown = '\f106';
export const iconArrowLeft = '\f107';
export const iconArrowRight = '\f108';
export const iconArrowUp = '\f109';
export const iconBackward15 = '\f10a';
export const iconBackward = '\f10b';
export const iconBan = '\f10c';
export const iconCaretDown = '\f10d';
export const iconCaretUp = '\f10e';
export const iconCheck = '\f10f';
export const iconClock = '\f110';
export const iconClose = '\f111';
export const iconCog = '\f112';
export const iconCogFilled = '\f113';
export const iconComputer = '\f114';
export const iconEnvelope = '\f115';
export const iconFacebook = '\f116';
export const iconForward15 = '\f117';
export const iconForward = '\f118';
export const iconFullscreenClose = '\f119';
export const iconFullscreen = '\f11a';
export const iconGooglePlus = '\f11b';
export const iconHeart = '\f11c';
export const iconHeartFilled = '\f11d';
export const iconInfo = '\f11e';
export const iconInfoFilled = '\f11f';
export const iconInstagram = '\f120';
export const iconKnifeFork = '\f121';
export const iconLanguage = '\f122';
export const iconLanguageFilled = '\f123';
export const iconExternal = '\f124';
export const iconMenu = '\f125';
export const iconMinus = '\f126';
export const iconMobile = '\f127';
export const iconNewWindow = '\f128';
export const iconNext = '\f129';
export const iconPause = '\f12a';
export const iconPen = '\f12b';
export const iconPhone = '\f12c';
export const iconPhoneFilled = '\f12d';
export const iconPlay = '\f12e';
export const iconPlus = '\f12f';
export const iconPosition = '\f130';
export const iconPrevious = '\f131';
export const iconRss = '\f132';
export const iconSchedule = '\f133';
export const iconSearch = '\f134';
export const iconShare = '\f135';
export const iconSight = '\f136';
export const iconSignLanguage = '\f137';
export const iconSlash = '\f138';
export const iconSoundHigher = '\f139';
export const iconSoundHigherFilled = '\f13a';
export const iconSoundLower = '\f13b';
export const iconSoundLowerFilled = '\f13c';
export const iconSoundOff = '\f13d';
export const iconSoundOffFilled = '\f13e';
export const iconSound = '\f13f';
export const iconSoundFilled = '\f140';
export const iconSpokenSubtitles = '\f141';
export const iconStop = '\f142';
export const iconTablet = '\f143';
export const iconText = '\f144';
export const iconTv = '\f145';
export const iconTwitter = '\f146';
export const iconViewGrid = '\f147';
export const iconViewList = '\f148';
export const iconWarning = '\f149';
export const iconWarningFilled = '\f14a';

/** SVG ICONS */
export const svgIconPlay =
    'PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSIzMCIgY3k9IjMwIiByPSIzMCIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC44Ii8+PHBhdGggZD0iTTI0IDE4VjQzTDQyIDMwLjVMMjQgMThaIiBmaWxsPSJibGFjayIvPjwvc3ZnPg==';
export const svgIconPlayOpaque =
    'PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSIzMCIgY3k9IjMwIiByPSIzMCIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMS4wIi8+PHBhdGggZD0iTTI0IDE4VjQzTDQyIDMwLjVMMjQgMThaIiBmaWxsPSJibGFjayIvPjwvc3ZnPg==';
export const svgIconNewWindow =
    'PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZD0iTTUuMDMxIDEuNXYuMDE2SDV2My45MzhIMS4wMTZ2LjAxNkgxdjcuNTQxYzAgLjgyMS42NjggMS40OSAxLjQ5IDEuNDlIOS41Yy44MjcgMCAxLjUtLjY3MyAxLjUtMS41di0yLjUxNmgyLjVjLjgyNyAwIDEuNS0uNjY5IDEuNS0xLjQ5VjEuNUg1LjAzMXpNMTAgMTMuNUgyVjcuNTA0aDN2MS40OWMwIC4wMDYuMDAyLjAxMS4wMDIuMDE2LjAwNC4zOTcuMTU3Ljc3LjQzNyAxLjA1LjI4NC4yODQuNjYxLjQ0IDEuMDYzLjQ0SDEwdjN6bTQtMy45OTZINnYtNmw4IC4wMTZ2NS45ODR6IiBmaWxsPSIjZmZmIi8+PC9zdmc+';
